import { defineMessages } from 'react-intl';

export const messages: {
	search: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	search: {
		defaultMessage: 'Search',
		description: 'Label for the Search trigger in the global top navigation.',
		id: 'global-top-navigation.search.search',
	},
});
